<template>
  <div class="fulldashboard">
      <div class="">
            in kürze Verfügbar 
      </div>
      
</div>
     
</template>

<script>

export default {
  
        data() {
            return {
                form: {
                    email: "",
                    password: ""
                }
                
            }
        },
    
}
</script>

<style scoped>
.containerStatisics{
  margin: 50px;
}



</style>